export const AVAILABLE = "available";
export const SELECTED = "selected";
export const UNAVAILABLE = "unavailable";
export const SOLD = "sold";
export const RESERVED = "reserved";
export const SELF_RESERVED = "self-reserved";
